import { Button } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { selectLang } from '../../../Contexts/lang/langueSlice';
import {getStatusCraLabel } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, sortDate } from '../../../Utils/utils';

export function navigate2CraCraX({rowData, role, lang, navigate,isEsn,isAchat}) {
    console.log(rowData);
    if(rowData?.craType == 'CRAX'){
        console.log({rowData});
        if(isEsn==true && isAchat==true)
            navigate(`/${role}/CraX/${rowData?._id}?lang=${lang}`,
                //* some infos for the expert update
                {state:  rowData}
            );
        else if(isEsn==true && isAchat==false)
            navigate(`/${role}/CraXVente/${rowData?._id}?lang=${lang}`,
                //* some infos for the expert update
                {state:  rowData}
            );
        else
            navigate(`/${role}/CraX/${rowData?._id}?lang=${lang}`,
                //* some infos for the expert update
                {state:  rowData}
            );
        // navigate(`/${role}/CraX/${rowData?._id}?lang=${lang}`,
        //     //* some infos for the expert update
        //     {state:  rowData}
        // );
    }
    else if(rowData?.craType == 'CRA'){
        if(isEsn==true && isAchat==true)
            window.open(`/${role}/Cra/${rowData?._id}?lang=${lang}`,'_blank'); //if we add the attribute 'rel=noopener noreferrer' == the referrer information will not be leaked. The end goal is not to miss the HTTP referrer title when a person clicks on a hyperlink. If there is no information in the title, it will not be tracked by analytical tools.
        else if(isEsn==true && isAchat==false)
            window.open(`/${role}/craVente/${rowData?._id}?lang=${lang}`,'_blank');
        else
            window.open(`/${role}/Cra/${rowData?._id}?lang=${lang}`,'_blank');
        // * SOL 1: refresh dans la mm page
        // navigate(`/${role}/Cra/${rowData?._id}`,);`/login?lang=${lang}`
        // location.reload();
        // * SOL 2: new Tab
        // window.open(`/${role}/Cra/${rowData?._id}?lang=${lang}`,'_blank'); //if we add the attribute 'rel=noopener noreferrer' == the referrer information will not be leaked. The end goal is not to miss the HTTP referrer title when a person clicks on a hyperlink. If there is no information in the title, it will not be tracked by analytical tools.
    }
}
const AllCraAdmin = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const [chargeRecrutementId,setChargeRecrutementId]=useState('');
    const [selectedRow, setSelectedRow] = React.useState(null);
    const { i18n } = useTranslation();
    const lang = useSelector(selectLang);
    const craColumnsAdmin = [
        {
            field: 'noCra',
            title: i18n.t('Réf.CRA'),
            render: (rowData) => (
                <Button
                    variant="text"
                    onClick={() =>navigate2CraCraX ({rowData, role,lang,isEsn:false,isAchat:false, navigate})}
                >
                    {rowData?.noCra}
                </Button>
            ),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutCraFinal',
            title: i18n.t('Statut du CRA'),
            render:  rowData =>
                i18n.t(rowData?.statutCraFinal)
            // ! soit print soit valeur a partir du backend :)
            // render:  rowData => (
            //     <>
            //         {getStatusCraLabel(rowData?.statutCra)}
            //     </>
            // )
        },
        {
            field: 'refClient',
            title: i18n.t('Réf.Client'),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du client'),
        },
        {
            field: 'refExpert',
            title: i18n.t('Réf.Expert'),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
        },
        {
            field: 'dateValidationExpert',
            title: i18n.t('Date de validation/Expert'),
        },
        {
            field: 'dateValidationClient',
            title: i18n.t('Date de validation/Client'),
        },
        {
            field: 'date',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.month)),
        },
        //{
        //    field: 'year',
        //    title: 'Année',
        //    //lookup: { 2023: '2023', 2022: '2022' },
        //},
        {
            field: 'nbJour',
            title: i18n.t('Nb jours validés'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'nbrJrsRestants',
            title: i18n.t('Nb.j. restants'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbrJrsRestants,'j');
            }
        },
        {
            field: 'tjExpert',
            title: i18n.t('TJ HT/Expert'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjExpert)
        },
        //{
        //    field: 'Date',
        //    title: 'Date',
        //},
        {
            field: 'tjClient',
            title: i18n.t('TJ HT/Client'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjClient)
        },
        {
            field: 'totalAstreintes',
            title: i18n.t('Total Astreintes'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalAstreintes)
        },
        {
            field: 'totalHno',
            title: i18n.t('Total HNO'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHno)
        },
        {
            field: 'totalNotesFrais',
            title: i18n.t('Total notes de frais'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalNotesFrais)
        },
        {
            field: 'totalHtExpert',
            title: i18n.t('Total HT/Expert'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHtExpert)
        },
        {
            field: 'totalHtClient',
            title: i18n.t('Total HT/Client'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHtClient)
        },

        {
            field: 'responsableOperationnel',
            title: i18n.t('Resp. opérationnel'),
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
    ];

    const role = useRole();
    const { setBackdropOpen} = useUtilities();
    //=============================================================================
    let navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [craRows, setCraRows] = React.useState();
    const [filtreCraAvalider, setFiltreCraAvalider] = useState(searchParams.get('filtreCraAvalider') === 'true');
    //useEffect(() => {
    //    if(role)
    //        getAllCra();
    //}, [role,chargeRecrutementId]);

    useEffect(() => {
        if(role)
            getMyInfos();
    }, [role,chargeRecrutementId]);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrecraavalider') ){
            setFiltreCraAvalider(false);
        }
    }, [url]);

    useEffect(() => {
        getMyInfos();
    }, [filtreCraAvalider]);

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            console.log('response.data?.backOffice?.roles?.chargeRecrutement',response.data?.backOffice?.roles?.chargeRecrutement);
            if((response.data?.backOffice?.roles?.chargeRecrutement==1)){
                setChargeRecrutementId(response.data?.backOffice?._id);
                await getAllCra(response.data?.backOffice?._id);
            }
            else
                await getAllCra('');

        } catch (error) {
            console.log(error);
        }
    };

    const mapCRA = (cra,nbrJrsRestants) => {
        let craType = cra?.statutCraX ? 'CRAX' : 'CRA';
        return (
            {
                'craType': craType,
                'noCra': craType == 'CRAX' ? cra?.craXId: cra?.craId,
                'intituleMission': cra?.missionId?.titre,
                'statutCraFinal': getStatusCraLabel(cra?.statutCra||cra?.statutCraX),
                'dateValidationExpert': formatDateJJMMYYYY(cra?.DateVE),
                'dateValidationClient': formatDateJJMMYYYY(cra?.DateVC),
                'nbrJrsRestants':nbrJrsRestants,
                //formatDateJJMMYYYY(facture?.craId?.DateVE) - formatDateJJMMYYYY(facture?.craId?.DateVC)
                //'Date':cra?.year+' , '+(cra?.month-1),
                //'month':dayjs(new Date(cra?.year, cra?.month-1))
                //    .locale(fr)
                //    .format('MMMM'),
                //'year': cra?.year,
                'Date':new Date(cra?.year, cra?.month - 1),
                //formatDateJJMMYYYY(facture?.craId?.DateVE) - formatDateJJMMYYYY(facture?.craId?.DateVC)
                'date':dayjs(new Date(cra?.year, cra?.month - 1)).locale('fr').format('MMMM YYYY'),
                'nbJour': cra?.nbrDays,
                // ? son't les colonnes qui controle l'affichage
                'refClient': cra?.missionId?.companyDataId?.clientId ?? cra?.missionId?.esnId?.esnId,
                'nomClient': cra?.missionId?.companyDataId?.profileEntreprise?.nom ?? cra?.missionId?.esnId?.profileEntreprise?.nom,
                'refExpert': cra?.missionId?.expertId?.expertId,
                'nomExpert':  getNomPrenomClearFromPersoData(cra?.missionId?.expertId?.persoData),
                'tjExpert': cra?.tj,
                'totalHtExpert': cra?.nbrDays ?(cra?.nbrDays * cra?.tj) : cra?.montantTotal,
                // /? Cra X
                'totalAstreintes': cra?.totalAstreintes,
                'totalHno': cra?.totalHnos,
                'totalNotesFrais': cra?.totalNotesFrais,
                'tjClient': cra?.tjClient,
                'totalHtClient': cra?.nbrDays ? (Number(cra?.nbrDays) * cra?.tjClient)
                    : cra?.montantTotalClient,
                // /? Cra X
                'responsableOperationnel': getNomPrenomClearFromPersoData(cra?.bdcId?.responsableOperationnelId?.persoData),
                'chargeRecrutement': getNomPrenomClearFromPersoData(cra?.bdcId?.backOfficeId?.persoData),
                ...cra
            }

        );
    };

    const isValidCra = cra => cra?.statutCra === 'VE' || cra?.statutCraX === 'VE';
    const isValidCR = (chargeRecrutementId,cra) => chargeRecrutementId && chargeRecrutementId==cra?.bdcId?.backOfficeId?._id;
    //=================================================================
    const getAllCra = async (chargeRecrutementId) => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get('/cra/getAllCra/', {
            // signal: controller.signal
            });
            let listCra = await response.data?.cras;
            let processedBdcIds=[];
            let nbrJrsRestants=0;
            let tempArray = [];
            if(filtreCraAvalider){
                listCra?.forEach(cra => {
                    nbrJrsRestants = cra?.bdcId?.nbJoursBDC;
                    if(isValidCR(chargeRecrutementId,cra) && isValidCra(cra) && !processedBdcIds.includes(cra?.bdcId?.bdcId) && !processedBdcIds.includes(cra?.bdcId?.bdcId)){
                        processedBdcIds.push(cra?.bdcId?.bdcId);
                        // Iterate through listCra to adjust nbrJrsRestants for matching bdcId
                        listCra?.forEach(prevCra => {
                            if (prevCra.bdcId?.bdcId === cra.bdcId?.bdcId && isValidCra(prevCra) && isValidCR(chargeRecrutementId,prevCra)) {
                                nbrJrsRestants =  nbrJrsRestants - (prevCra.nbrDays ?? 0);
                                tempArray.push(mapCRA(prevCra,nbrJrsRestants));
                            }
                        });
                    }
                    if(chargeRecrutementId=='' && !processedBdcIds.includes(cra?.bdcId?.bdcId)){
                        processedBdcIds.push(cra?.bdcId?.bdcId);
                        listCra?.forEach(prevCra => {
                            if (prevCra.bdcId?.bdcId === cra.bdcId?.bdcId && isValidCra(prevCra) && chargeRecrutementId=='') {
                                nbrJrsRestants =  nbrJrsRestants - (prevCra.nbrDays ?? 0);
                                tempArray.push(mapCRA(prevCra,nbrJrsRestants));
                            }
                        });
                    }
                });
            }
            else{
                listCra?.forEach(cra => {
                    nbrJrsRestants = cra?.bdcId?.nbJoursBDC;
                    if(isValidCR(chargeRecrutementId,cra) && !processedBdcIds.includes(cra?.bdcId?.bdcId)){
                        processedBdcIds.push(cra?.bdcId?.bdcId);
                        listCra?.forEach(prevCra => {
                            if (prevCra.bdcId?.bdcId === cra.bdcId?.bdcId && isValidCR(chargeRecrutementId,cra)) {
                                nbrJrsRestants =  nbrJrsRestants - (prevCra?.nbrDays ?? 0);
                                tempArray.push(mapCRA(prevCra,nbrJrsRestants));
                            }
                        });
                    }
                    if(chargeRecrutementId=='' && !processedBdcIds.includes(cra?.bdcId?.bdcId)){
                        processedBdcIds.push(cra?.bdcId?.bdcId);
                        listCra?.forEach(prevCra => {
                            if (prevCra.bdcId?.bdcId === cra.bdcId?.bdcId && chargeRecrutementId=='') {
                                nbrJrsRestants =  nbrJrsRestants - (prevCra?.nbrDays ?? 0);
                                tempArray.push(mapCRA(prevCra,nbrJrsRestants));
                            }
                        });
                    }
                });
            }

            setCraRows(sortDate(tempArray));

        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('Gestion des missions')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {i18n.t('CRA')}</span>
            </div>
            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Liste des CRA')}
                </h4>

                <MaterialTableComponent
                    data={craRows}
                    columns={craColumnsAdmin}
                    title={i18n.t('CRA')}
                    //options={{filtering: true}}
                    onRowClick={(event, rowData) => {
                        //setRowSelected(rowData);
                        setSelectedRow(rowData?.tableData.id);
                        //console.log(rowData);
                        //if(rowData?.craType == 'CRAX'){
                        //    console.log({rowData});
                        //    navigate(`/${role}/CraX/${rowData?._id}`,
                        //        //* some infos for the expert update
                        //        {state:  rowData}
                        //    );
                        //}
                        //else if(rowData?.craType == 'CRA'){
                        //    navigate(`/${role}/Cra/${rowData?._id}`,);}
                    }}
                    selectedRow={selectedRow}
                />

                {/*<div className='Frame4AllAOs'>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            icons={tableIcons}
                            data={craRows}
                            columns={craColumns}
                            title="CRA"
                            options={materialTableOptions}
                            onRowClick={(event, rowData) => {
                                // setRowSelected(rowData);
                                console.log(rowData);
                                if(rowData?.craType == 'CRAX'){
                                    console.log({rowData});
                                    navigate(`/${role}/CraX/${rowData?._id}`,
                                        //* some infos for the expert update
                                        {state:  rowData}
                                    );
                                }
                                else if(rowData?.craType == 'CRA'){
                                    navigate(`/${role}/Cra/${rowData?._id}`,);}
                            }}
                        />
                    </ThemeProvider>
                </div>*/}
            </div>
        </>
    );
};

export default AllCraAdmin;